<template>
  <div class="row">
    <b-form-group class="col-lg-12 col-sm-12 mx-0 my-0 padding-fix">
      <b-input-group>
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelInvoiceType', 'labelInvoiceType') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-select v-model="invoicingFreeTextItem.batch_type" :options="invoicingTypes" value-field="id" text-field="name">
          <template #first>
            <b-form-select-option :value="null" disabled> {{t('optionSelectInvoiceType', 'optionSelectInvoiceType')}} </b-form-select-option>
          </template>
          <b-form-select-option :value="0"> {{t('optionOther', 'optionOther')}} </b-form-select-option>
        </b-form-select>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelDescription', 'labelDescription') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-textarea v-model="invoicingFreeTextItem.description" class="form-control" rows="4" max-rows="4">
        </b-form-textarea>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelIssueTrackerNum', 'labelIssueTrackerNum') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="number" min="0" step="1" v-model.number="invoicingFreeTextItem.issue_tracker_num" class="form-control"/>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelQuantity', 'labelQuantity') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="number" min="0" step="0.01" v-model.number="invoicingFreeTextItem.quantity" class="form-control"/>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelRate', 'labelRate') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="number" min="0" step="0.01" v-model.number="invoicingFreeTextItem.rate" class="form-control"/>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelTotal', 'labelTotal') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="number" min="0" step="0.01" v-model.number="invoicingFreeTextItem.total" class="form-control"/>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelOneOff', 'labelOneOff') }} </span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-select v-model="invoicingFreeTextItem.one_off">
          <template #first>
            <b-form-select-option :value="null" disabled> {{t('optionSelectOneOff', 'optionSelectOneOff')}} </b-form-select-option>
          </template>
          <b-form-select-option :value="0"> {{t('optionNo', 'optionNo')}} </b-form-select-option>
          <b-form-select-option :value="1"> {{t('optionYes', 'optionYes')}} </b-form-select-option>
        </b-form-select>
        <div class="col-lg-12 py-1">
          <span class="pretext-span tips-font-size"> {{t('oneOffTips', 'oneOffTips')}}</span>
        </div>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelIncVat', 'labelIncVat') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-select v-model="invoicingFreeTextItem.vat_code">
          <template #first>
            <b-form-select-option :value="null" disabled> {{t('optionSelectVatCode', 'optionSelectVatCode')}} </b-form-select-option>
          </template>
          <b-form-select-option :value="0"> {{t('optionNo', 'optionNo')}} </b-form-select-option>
          <b-form-select-option :value="1"> {{t('optionYes', 'optionYes')}} </b-form-select-option>
        </b-form-select>
      </b-input-group>

      <b-input-group class="mt-3">
        <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
          <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelStatus', 'labelStatus') }}</span></b-input-group-text>
        </b-input-group-prepend>
        <b-form-select v-model="invoicingFreeTextItem.status" :options="invoicingBatchStatuses" value-field="id" text-field="name">
          <template #first>
            <b-form-select-option :value="null" disabled> {{t('optionSelectBatchStatus', 'optionSelectBatchStatus')}} </b-form-select-option>
          </template>
        </b-form-select>
      </b-input-group>
    </b-form-group>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AddFreeTextInvoiceForm",
  props: [
      'invoicingFreeTextItem',
  ],
  computed: {
    invoicingBatchStatuses: {
      get() {
        return this.$store.getters.getInvoicingBatchStatuses
      }
    },
    invoicingTypes: {
      get() {
        return this.$store.getters.getInvoicingBatchTypes
      }
    },
  },
}
</script>

<style scoped>

</style>